import { BrowserRouter, Switch, Redirect, Route } from "react-router-dom";
import { useEffect } from "react";

import ReactGA from "react-ga";

import AppTermsOfUse from "./pages/AppTermsOfUse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NewStartHere from "./pages/NewStartHere";
import SuccessPage from "./pages/SuccessPage";
import MealServices from "./pages/MealServices";
import ComingSoon from "./pages/ComingSoon";
import Overview from "./pages/Overview";
import Programs from "./pages/Programs";
import Careers from "./pages/Careers";
import Clients from "./pages/Clients";
import Contact from "./pages/Contact";
import Updates from "./pages/Updates";
import Header from "./components/Header";
import SideNav from "./components/SideNav";
import Footer from "./components/Footer";

import ScrollToTop from "./utils/helperFunctions";

import "./App.css";

function App() {
  useEffect(() => {
    ReactGA.initialize("UA-231259088-1");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <SideNav />
        <ScrollToTop>
          <Switch>
            <Route exact path="/" component={Overview} />
            <Route path="/newStartHere" component={NewStartHere} />
            <Route path="/programs" component={Programs} />
            <Route path="/careers" component={Careers} />
            <Route path="/clients" component={Clients} />
            <Route path="/contact" component={Contact} />
            <Route path="/updates" component={Updates} />
            <Route path="/comingSoon" component={ComingSoon} />
            <Route path="/mealServices" component={MealServices} />
            <Route path="/appTermsOfUse" component={AppTermsOfUse} />
            <Route path="/privacyPolicy" component={PrivacyPolicy} />
            <Route path="/success" component={SuccessPage} />
            <Route render={() => <Redirect to={{ pathname: "/" }} />} />
          </Switch>
        </ScrollToTop>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
